import { MchInfo as MchInfoI } from '../types/MchInfo';

export class MchInfo implements MchInfoI {
    id!: number;

    mchName!: string;

    mobile!: string;

    email!: string;
}
